import Column from '@components/column'
import CardHeading from '@commons/headings/card'
import Circle from '@components/circle'
import Typography from '@components/typography'
import AppointmentSchedule from '@commons/cards/appointmentSchedule'
import ScrollView from '@commons/scroll'
import { styleCardItem } from './style'
const TodayAppointments = () => {
  return (
    <>
      <CardHeading
        title={`Todays Appointments`}
        titleRightComponent={
          <Circle bg="secondary" size={20}>
            <Typography content={`8`} size={12} tc="white" />
          </Circle>
        }
        hasView
      />

      <Column
        bg="primary300"
        styleColumn="padding:20px;border-radius:8px;oveflow:hidden"
      >
        <ScrollView>
          <AppointmentSchedule styleCard={styleCardItem} />
          <AppointmentSchedule styleCard={styleCardItem} />
          <AppointmentSchedule styleCard={styleCardItem} />
          <AppointmentSchedule styleCard={styleCardItem} />
          <AppointmentSchedule styleCard={styleCardItem} />
          <AppointmentSchedule styleCard={styleCardItem} />
          <AppointmentSchedule styleCard={styleCardItem} />
          <AppointmentSchedule styleCard={styleCardItem} />
        </ScrollView>
      </Column>
    </>
  )
}

export default TodayAppointments
